

import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { environment } from '../environments/environment';
import { IndexedDBAngular } from 'indexeddb-angular';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { LocalServerService } from './ngage-apps/lots/MU_pages/toyota-pages/services/localserver.service';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss']
})
export class AppComponent {
    showath=false;
    constructor(
        private platform: Platform,
        private splashScreen: SplashScreen,
        private statusBar: StatusBar,
        private location:Location,
        private local:LocalServerService,
        private route: ActivatedRoute
    ) {
        this.initializeApp();
    }

    deferredPrompt;
    initializeApp() {
        this.route.queryParams.subscribe(params => {
            if(params['source']) {
                console.log("source found", params['source'])
                localStorage.setItem('source', params['source'])
            }
        })
        //this.location.replaceState('/');
        this.showath=false;
        this.platform.ready().then(() => {
            this.statusBar.styleDefault();
            this.splashScreen.hide();
        });
        var me=this;
        window.addEventListener('beforeinstallprompt', (e) => {
            e.preventDefault();
            me.deferredPrompt = e;
            me.showath=true; 
            if(localStorage.getItem("notoATH")=="yes")me.showath=false;      
        });
        window.addEventListener('appinstalled', (evt) => {
            this.showath=false;
        });

       

    }

    ona2hbtn() {
        this.showath=false;
        this.deferredPrompt.prompt();
        this.deferredPrompt.userChoice
            .then((choiceResult) => {
                if (choiceResult.outcome === 'accepted') {
                    console.log('User accepted the A2HS prompt');
                } else {
                    console.log('User dismissed the A2HS prompt');
                }
                this.showath=false;
                this.deferredPrompt = null;
            });
    }

    close()
    {
        this.showath=false;
        console.log('User dismissed the A2HS prompt');
        localStorage.setItem("notoATH",'yes');
    }
}



